import { get as g } from 'lodash';
import { createSelector } from 'reselect';

const stateSelector = (state) => g(state, 'notifications');

// eslint-disable-next-line import/prefer-default-export
export const spawnedNotificationsSelector = createSelector(
	// eslint-disable-line
	stateSelector,
	(state) => g(state, 'spawnedNotifications')
);
